<div class="ver-container">
  <mat-card class="ver-form-container">
    <form class="ver-form" [formGroup]="_form" (ngSubmit)="verify()">
      <!-- Label -->
      <div class="ver-title">
        <!-- <p
                    class="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">
                    Verification
                </p> -->
        <ddc-text-gradient class="text-4xl" [_text]="'Verification'" [_type]="'1'"> </ddc-text-gradient>
        <p class="text-1xl font-bold">
          Please verify the code we sent to your email
          <ddc-text-gradient class="text-1xl" [_text]="_email" [_type]="'2'"> </ddc-text-gradient>
        </p>
      </div>
      <!-- ! Form Error -->
      <div class="alert alert-danger" *ngIf="_form.errors">
        {{ _VerError }}
      </div>
      <!-- ! First name -->
      <mat-form-field class="ver-code">
        <mat-label>6 Digits Code</mat-label>
        <input formControlName="_code" matInput placeholder="Ex. 760254" />
        <!-- * Errors -->
        <mat-error *ngIf="code.hasError('required')"> Verification code is <strong>required</strong> </mat-error>
        <mat-error *ngIf="code.hasError('maxlength')">
          It should have <strong>{{ _codeLength }}</strong> digits.
        </mat-error>
        <mat-error *ngIf="code.hasError('pattern')"> It should be 6 digits number. </mat-error>
      </mat-form-field>
      <!-- ! Agreement -->
      <div class="agreement-container text-sm">
        It can take <a class="font-semibold text-teal-600" color="primary">few minutes </a>
        if the server is high traffic.
      </div>
      <!-- ! Submit button -->
      <ddc-button-s-one
        [_icon]="'fingerprint'"
        [_isLoading]="_isVerBtnLoading"
        [_label]="_submitBtnText"
      ></ddc-button-s-one>
    </form>

    <mat-divider></mat-divider>
    <!-- To Login -->
    <div class="ver-ver">
      <!-- ! Label -->
      <p>Not your email?</p>
      <!-- ! Submit -->
      <ddc-button-r-one
        [dynamicRoute]="'/signup'"
        [icon]="'how_to_reg'"
        [label]="'Sign up with another email'"
        [type]="'route'"
      >
      </ddc-button-r-one>
    </div>
    <div class="ver-ver">
      <!-- ! Label -->
      <p>Have you already verified?</p>
      <!-- ! Submit -->
      <ddc-button-r-one [dynamicRoute]="'/login'" [icon]="'login'" [label]="'Login'" [type]="'route'">
      </ddc-button-r-one>
    </div>
  </mat-card>
</div>
